import { EmbedPage } from "@/features/supabase";
import type { Props } from "../types";

/** The fields `buildEmbedProps` reads -- satisfied by both `EmbedPage` and `AdminDataset`. */
export type EmbeddableRow = Pick<EmbedPage, "id" | "embed_type" | "embed_slug">;

/**
 * Maps an embed page row to the Props needed to render it via `Embed`.
 */
export const buildEmbedProps = (data: EmbeddableRow): Props | undefined => {
  switch (data.embed_type) {
    case "airtable":
      return { type: "airtable", slug: data.embed_slug };

    case "metabase-dashboard":
      return { type: "metabaseDashboard", id: data.embed_slug };

    case "metabase-guest-embed":
      return { type: "metabaseGuestEmbed", embedPageId: data.id };

    case "scribe":
      return { type: "scribe", slug: data.embed_slug };

    case "youtube":
      return { type: "youtube", id: data.embed_slug };
  }
};

/**
 * This is for "open in new tab" of embeds.
 * NOTE: This should generally be different to the `src` tag in the embeds.
 */
export const getExternalUrlForEmbed = (props: Props): string | undefined => {
  switch (props.type) {
    case "scribe":
      return `https://scribehow.com/shared/${props.slug}`;

    case "youtube":
      return `https://www.youtube.com/watch?v=${props.id}`;

    default:
      return;
  }
};
